module.exports = __webpack_public_path__ + "static/cv-4c3cf6c7889ac9d9556abc977394fc7b.pdf";